import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 border-t border-background-700">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg group-hover:bg-primary-400 transition-colors duration-300">
                <i className="ri-movie-2-fill text-lg text-background-950"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">日韩影视网</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              免费日韩电影在线观看平台，提供高清日本电影和韩国电影，每日更新最新大片。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all duration-200" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-label">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">电影分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-label">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/article/your-name" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">你的名字</Link></li>
              <li><Link to="/article/parasite" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">寄生虫</Link></li>
              <li><Link to="/article/spirited-away" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">千与千寻</Link></li>
              <li><Link to="/article/train-to-busan" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">釜山行</Link></li>
              <li><Link to="/article/decision-to-leave" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">分手的决心</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-label">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">联系我们</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-150">常见问题</Link></li>
            </ul>
            <div className="mt-4 pt-4 border-t border-background-700">
              <p className="text-sm text-foreground-500">
                联系邮箱：<a href="mailto:contact@rihanyingshi.com" className="text-primary-400 hover:text-primary-300 transition-colors">contact@rihanyingshi.com</a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 日韩影视网 - 免费日韩电影在线观看。本站所有内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-foreground-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-foreground-400 transition-colors">使用条款</a>
            <a href="#" className="hover:text-foreground-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}